import { apiFetch, apiPost } from "./api";

export type SessionState = "active" | "mfa" | "mfa_setup" | "password_change";

export interface Me {
  state: SessionState;
  user: {
    id: number;
    username: string;
    display_name: string;
    email: string | null;
    totp_enabled: boolean;
    must_change_password: boolean;
  };
  permissions: string[];
  is_admin: boolean;
  roles: string[];
  password_min_length: number;
  /** Set while an administrator sees the interface as `user` ("view as", read-only). */
  viewing_as?: { username: string; display_name: string } | null;
  is_root?: boolean;
  /** How far the data scope reaches: every queue, some, or none (no queue rule at all). */
  data_scope?: "all" | "some" | "none";
}

export interface StateResponse {
  state: SessionState;
}

export interface TotpSetup {
  secret: string;
  uri: string;
  qr_svg: string;
}

export const getMe = (): Promise<Me> => apiFetch<Me>("/auth/me");
export const login = (username: string, password: string) =>
  apiPost<StateResponse>("/auth/login", { username, password });
export const verifyTotp = (code: string) => apiPost<StateResponse>("/auth/login/2fa", { code });
export const logout = () => apiPost<void>("/auth/logout");
export const stopViewAs = () => apiPost<void>("/auth/view-as/stop");
export const changePassword = (current_password: string, new_password: string) =>
  apiPost<StateResponse>("/auth/password", { current_password, new_password });
export const startTotpSetup = () => apiPost<TotpSetup>("/auth/2fa/setup");
export const enableTotp = (code: string) => apiPost<StateResponse>("/auth/2fa/enable", { code });
export const disableTotp = (password: string, code: string) =>
  apiPost<void>("/auth/2fa/disable", { password, code });

export const meQueryKey = ["auth", "me"] as const;
